import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import app from "./modules/app";
import session from "./modules/session";
import account from "./modules/account";
import user from "./modules/user";
import role from "./modules/role";
import tenant from "./modules/tenant";
import categoryfile from "./modules/categoryfile";
import category from "./modules/category";
import unit from "./modules/unit";
import unitImport from "./modules/unit-import";
import client from "./modules/client";
import config from "./modules/config";
import product from "./modules/product";
import productImport from "./modules/product-import";
import purchaseOrder from "./modules/purchase-order";
import purchaseOrderImport from "./modules/purchase-order-import";
import warehouse from "./modules/warehouse";
import inventoryReport from "./modules/inventoryReport";
import saleOrderImport from "./modules/sale-order-import";
import saleOrder from "./modules/sale-order";
import location from "./modules/location";
import pickwaveCreated from "./modules/pick-wave-created";
import ref from "./modules/ref";
import geoLocation from "./modules/geo-location";
import transportImport from "./modules/transport-import";
import transport from "./modules/transport";
import binImport from "./modules/bin-import";
import bin from "./modules/bin";
import picklist from "./modules/pick-list";
import packing from "./modules/packing";
import handoverSession from "./modules/handoversession";
import tpl from "./modules/tpl";
import handoverSessionLine from "./modules/handoversessionline";
import handoverSessionPackages from "./modules/handoversession-packages";
import deliveryPackage from "./modules/delivery-package";
import masterData from "./modules/master-data";
import report from "./modules/report";
import purchasingStatistics from "./modules/purchasing-statistics";
import salesStatistics from "./modules/sales-statistics";
import transferOrder from "./modules/transfer-order";
import inboundException from "./modules/inbound-exception";
import lostFound from "./modules/lost-found";
import customer from "./modules/customer";
import productPricing from "./modules/product-pricing";
import supplier from "./modules/supplier";
import customerType from "./modules/customer-type";
import preorderShortedSku from "./modules/preorder-shorted-sku";
import paSoShortedSku from "./modules/pa-so-shorted-sku";
import vwSoLine from "./modules/vw-so-line";
import room from "./modules/room";
import aisle from "./modules/aisle";
import invoiceSeq from "./modules/invoice-seq";
import receivePhysical from "./modules/receive-physical";
import employeeJobDiary from "./modules/employee-job-diary";
import employeeJobDiaryDetail from "./modules/employee-job-diary-detail";
import inventoryReportDetail from "./modules/inventoryReportDetail";
import customerStatementReport from "./modules/customerStatementReport";
import deliveryPackageGroup from "./modules/grouping-package";
import generalInventoryReport from "./modules/generalInventoryReport";
import locationLocking from "./modules/locationlocking";
import locationLockingLine from "./modules/locationlockingline";
import generalInventoryReportDetail from "./modules/generalInventoryReportDetail";
import caseLabel from "./modules/case-label";
import transferOrderImport from "./modules/transfer-order-import";
import saleOrderRequest from "./modules/sale-order-request";
import saleOrderRequestImport from "./modules/sale-order-request-import";
import deliveryNote from "./modules/delivery-note";
import collectionCode from "./modules/collectionCode";
import collectionCodeTracking from "./modules/collectionCodeTracking";
import sessionPrintCollectionCode from "./modules/sessionPrintCollectionCode";
import errorLog from "./modules/errorLog";
import returnOrder from "./modules/returnOrder";
import returnOrderReceipt from "./modules/returnOrderReceipt";
import warrantyActivation from "./modules/warranty-activation";
import poReceipt from "./modules/po-receipt";
import collectionCodeProduct from "./modules/collectionCode-product";
import reportCollectionCodeChange from "./modules/reportCollectionCodeChange";
import refPickList from "./modules/ref-pick-list";
import soLinePickList from "./modules/so-line-pick-list";
import reportWarrantyActivation from "./modules/report-warranty-activation";
import poTracking from "./modules/po-tracking";
import warrantyDurationConfig from "./modules/warrantyDurationConfig";
import TimeAllowsWarrantyActivateConfig from "./modules/TimeAllowsWarrantyActivateConfig";


const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {},
  modules: {
    app,
    session,
    account,
    user,
    role,
    tenant,
    categoryfile,
    category,
    unit,
    client,
    unitImport,
    config,
    product,
    productImport,
    purchaseOrder,
    purchaseOrderImport,
    warehouse,
    inventoryReport,
    saleOrderImport,
    saleOrder,
    location,
    pickwaveCreated,
    ref,
    geoLocation,
    transportImport,
    transport,
    bin,
    binImport,
    picklist,
    packing,
    handoverSession,
    tpl,
    handoverSessionLine,
    handoverSessionPackages,
    deliveryPackage,
    masterData,
    report,
    purchasingStatistics,
    salesStatistics,
    transferOrder,
    inboundException,
    lostFound,
    customer,
    productPricing,
    supplier,
    customerType,
    preorderShortedSku,
    paSoShortedSku,
    vwSoLine,
    room,
    aisle,
    invoiceSeq,
    receivePhysical,
    employeeJobDiary,
    employeeJobDiaryDetail,
    inventoryReportDetail,
    customerStatementReport,
    deliveryPackageGroup,
    generalInventoryReport,
    locationLocking,
    locationLockingLine,
    generalInventoryReportDetail,
    caseLabel,
    transferOrderImport,
    saleOrderRequest,
    saleOrderRequestImport,
    deliveryNote,
    collectionCode,
    collectionCodeTracking,
    sessionPrintCollectionCode,
    errorLog,
    returnOrder,
    returnOrderReceipt,
    warrantyActivation,
    poReceipt,
    collectionCodeProduct,
    reportCollectionCodeChange,
    refPickList,
    soLinePickList,
    reportWarrantyActivation,
    poTracking,
    warrantyDurationConfig,
    TimeAllowsWarrantyActivateConfig
  },
});

export default store;
